import { useEffect, useState } from 'react';
import {
  subscribeLabelTemplates,
  type LabelTemplateListResult,
} from '@/lib/firestoreLabelTemplates';

/**
 * Hook que envolve `subscribeLabelTemplates` em estado React. Retorna
 * `LOADING` no primeiro tick, `READY`/`ERROR` em seguida. Limpa o
 * listener no unmount e quando `tenantId` muda. *
 * Origem: sem issue — commit a5ee68045, 2026-04-29 21:29 +0200 (Sprint 15 PR D,
 * Label Templates por tenant).
 *
 * Usado por: `features/labelTemplates/LabelTemplatesTab.tsx` (aba Modelos).
 *
 * Dados: `tenants/{tenantId}/labelTemplates` por `updatedAt desc`, validado por
 * `LabelTemplateSchema` em `lib/firestoreLabelTemplates.ts`.
 *
 * Falhas conhecidas: documento fora do schema é descartado no `lib/` só com
 * `console.warn`, e erro do listener só com `console.error` — nenhum dos dois
 * chega à telemetria (CLAUDE.md "Observabilidade"; ver #926, achados).
 */
export function useLabelTemplates(tenantId: string): LabelTemplateListResult {
  const [result, setResult] = useState<LabelTemplateListResult>({ kind: 'LOADING' });

  useEffect(() => {
    if (!tenantId) {
      setResult({ kind: 'LOADING' });
      return;
    }
    setResult({ kind: 'LOADING' });
    const unsub = subscribeLabelTemplates(tenantId, setResult);
    return unsub;
  }, [tenantId]);

  return result;
}
